import { action } from 'mobx';
import { BasePreviewViewStore} from 'core/stores';
import {applicationContext} from 'core/utils';
import { PatientDetailService } from 'application/import/services';

@applicationContext
class ImportPatientPreviewViewStore extends BasePreviewViewStore {
    constructor(rootStore) {
        const patientDetailService = new PatientDetailService(rootStore.application.baasic.apiClient);
        const id = rootStore.routerStore.routerState.params.id;

        super(rootStore, {
            name: 'patient-detail',
            autoInit: true,
            id: id,
            actions: () => {
                return {
                    get: async (id) => {
                        const response = await patientDetailService.get(id, { embed: 'PatientDetailDiagnosisCodes' });
                        return response.data;
                    }
                }
            }
        });
    }
    @action.bound
    async getResource(id) {
        await super.getResource(id);
    }
}

export default ImportPatientPreviewViewStore;
